import { FC } from 'react';
import './WeatherSkeleton.scss';

const WeatherSkeleton: FC = () => {
  return (
    <div className="weather-skeleton__container" data-testid="weather-skeleton">
      <div className="weather-skeleton__shimmer"></div>
    </div>
  );
};

export default WeatherSkeleton;
